<template>
  <div class="page" style="min-height: 100vh; padding:0vw 0vw; background-size:100% 100%">
    <div style="padding: 3vw">
      <div>
        <div class="data-dashboard">
          <div style="text-align: center;font-size: 5vw;color: #c7e6ff;font-weight: bold;padding: 3vw">
            数据统计中心
          </div>

          <!-- 数据概览 -->
          <div style="margin-top: 3vw;width: 100%">
            <div style="display:flex; justify-content: space-between">
              <span style="color: white;font-size: 4.11vw;font-weight: bold">核心指标</span>
              <span style="color: #a6d3ff">更新时间: {{ updateTime }}</span>
            </div>
            <div style="display: flex;margin-top: 3vw;justify-content: space-between;align-items: center;">
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/01.png" style="width: 8vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">总充值金额</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.totalRecharge) }}
                  </div>
                </div>
              </div>
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;margin-left: 2vw; padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/02.png" style="width: 8vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">今日充值金额</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.todayRecharge) }}
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex;margin-top: 2vw;justify-content: space-between;align-items: center;">
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/05.png" style="width: 8vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">今日充值笔数</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.todayRechargeCount) }}
                  </div>
                </div>
              </div>
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;margin-left: 2vw; padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/06.png" style="width: 8vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">总提现金额</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.totalWithdraw) }}
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex;margin-top: 2vw;justify-content: space-between;align-items: center;">
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/07.png" style="width: 9vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">今日提现金额</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.todayWithdraw) }}
                  </div>
                </div>
              </div>
              <div style="background-color: #022c69bd;width: 47%;border-radius: 8px;margin-left: 2vw; padding: 2vw;display: flex;align-items: center;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);border: 1px solid rgba(74, 144, 226, 0.2);transition: all 0.3s;">
                <div style="width: 10vw; display: flex; align-items: center; justify-items: center; justify-content: center; text-align: center;height: 10vw; background-color: rgba(24, 144, 255, 0); border-radius: 50%">
                  <img src="../../assets/icon/05.png" style="width: 8vw" />
                </div>
                <div style="padding-left: 2vw">
                  <div style="font-size: 13px;color: #91bcff;margin-bottom: 5px;">今日提现笔数</div>
                  <div style="font-size: 15px;font-weight: bold;background: linear-gradient(to bottom, #e2ff00, #ffffff);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
                    {{ formatMoney(stats.todayWithdrawCount) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 图表区域 -->
          <div class="chart-section">
            <div class="section-title">
              <span style="color:#91bcff;font-size: 4.11vw;font-weight: bold">未来5天平仓趋势</span>
            </div>
            <div class="chart-container" ref="chartContainer"></div>
          </div>

          <!-- 底部统计 -->
          <div class="bottom-stats">
            <van-tabs v-model="activeTab">
              <van-tab title="用户统计">
                <div class="stats-grid">
                  <div class="stat-item">
                    <div class="stat-label">总注册人数</div>
                    <div class="stat-value">{{ stats.totalRegister }}</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-label">建仓过人数</div>
                    <div class="stat-value">{{ stats.totalPosition }}</div>
                  </div>
                  <!-- 更多统计项... -->
                </div>
              </van-tab>
              <van-tab title="资金统计">
                <div class="stats-grid">
                  <div class="stat-item">
                    <div class="stat-label">平台总余额</div>
                    <div class="stat-value">{{ formatMoney(stats.totalBalance) }}</div>
                  </div>
                  <!-- 更多资金统计项... -->
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {axiosPost} from "@/main";
// import axios from "axios";
import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import * as echarts from 'echarts';
import { format } from 'date-fns';

export default {
  name:"BossLoginAdminSystem",
  data(){
    return{
      activeTab: 0,
      updateTime: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      stats: {
        // 充值相关
        totalRecharge: 12568943.56,
        todayRecharge: 356892.34,
        todayRechargeCount: 128,

        // 提现相关
        totalWithdraw: 8569321.78,
        todayWithdraw: 125893.45,
        todayWithdrawCount: 56,

        // 平仓相关
        yesterdayClose: 356892.34,
        futureClose: [120000, 300000, 150000, 80000, 70000], // 未来5天

        // 用户相关
        totalRegister: 12589,
        totalPosition: 8562,
        todayRegister: 128,
        todayPosition: 56,
        inactiveOver30Days: 1258,
        unverifiedRegister: 356,
        registeredNotRecharged: 892,

        // 建仓相关
        todayPositionAmount: 356892.34,
        todayPositionCount: 128,

        // 收益相关
        todaySendProfit: 56892.34,
        yesterdaySendProfit: 125893.45,

        // 其他
        totalBalance: 35689234.56,
        todayLogin: 1258,
        todayTransfer: 356892.34
      }
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);

  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },

  methods:{
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chartContainer);

      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五'],
          axisLine: {
            lineStyle: {
              color: '#4a90e2'
            }
          },
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#4a90e2'
            }
          },
          axisLabel: {
            color: '#fff',
            formatter: '{value}'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(74, 144, 226, 0.3)'
            }
          }
        },
        series: [
          {
            name: '平仓金额',
            type: 'line',
            data: this.stats.futureClose,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 0.8, [
                { offset: 0, color: 'rgba(58, 77, 233, 0.8)' },
                { offset: 1, color: 'rgba(58, 77, 233, 0.1)' }
              ])
            }
          }
        ]
      };

      this.chartInstance.setOption(option);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    formatMoney(value) {
      return '¥' + value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    onClickLeft() {
      console.log('返回');
    },
    onClickRight() {
      console.log('刷新');
      // 这里可以添加数据刷新逻辑
      this.updateTime = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    }
  }
}
</script>

<style scoped>
.page{
  background-image:url('../../assets/map1.jpeg');
}
.data-dashboard {
  min-height: 100vh;
  color: var(--text-color);
  padding-bottom: 50px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;

  .nav-bar {
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    color: white;

    .van-nav-bar__title {
      color: white;
      font-weight: bold;
    }
  }

  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid rgba(74, 144, 226, 0.3);

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      background: linear-gradient(90deg, #4facfe, #00f2fe);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .update-time {
      font-size: 12px;
      color: var(--text-secondary);
    }
  }

  .data-grid {
    width: 100vw;
    overflow-x: hidden;
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 2vw;
    padding: 0px;
  }

  .data-card {
    background-color: #022c69bd;
    border-radius: 8px;
    padding: 2vw;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(74, 144, 226, 0.2);
    transition: all 0.3s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    .card-icon {
      width: 40px;
      height: 40px;
      background: rgba(24, 144, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;

      .iconfont {
        font-size: 20px;
        color: var(--primary-color);
      }
    }

    .card-content {
      flex: 1;

      .card-title {
        font-size: 14px;
        color: #91bcff;
        margin-bottom: 5px;
      }

      .card-value {
        font-size: 12px;
        font-weight: bold;
        background: linear-gradient(to bottom, #e2ff00, #ffffff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }

  .chart-section {
    margin-top: 20px;
    background-color: #022c69bd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(74, 144, 226, 0.2);

    .chart-container {
      width: 100%;
      height: 300px;
    }
  }

  .bottom-stats {
    margin-top: 20px;
    background: var(--card-bg);
    border-radius: 8px;
    overflow: hidden;
    margin: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(74, 144, 226, 0.2);

    .van-tabs {
      .van-tabs__wrap {
        background: rgba(16, 42, 84, 0.9);
      }

      .van-tab--active {
        color: var(--primary-color);
      }

      .van-tabs__line {
        background: var(--primary-color);
      }
    }

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      padding: 15px;

      .stat-item {
        background: rgba(24, 144, 255, 0.1);
        border-radius: 4px;
        padding: 10px;
        text-align: center;

        .stat-label {
          font-size: 12px;
          color: var(--text-secondary);
          margin-bottom: 5px;
        }

        .stat-value {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
